import styled from 'styled-components';
import { COLORS, device, FONTS } from '../../constants';

const Container = styled.div`
  text-align: left;
  font-family: ${FONTS.SUBTITLE};
`;

const Title = styled.h6`
  color: ${COLORS.WHITE};
  font-family: ${FONTS.SUBTITLE};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 0 0 20px 0;
  @media screen and ${device.md} {
    display: none;
  }
`;

const StyledLink = styled.a`
  color: ${COLORS.FOOTER_TEXT_COLOR};
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  text-decoration: none;
  display: block;
  margin-bottom: 20px;
  font-family: ${FONTS.SUBTITLE};

  &:hover {
    text-decoration: underline;
    color: ${COLORS.MAIN_RED};
  }
`;
const DividerWrapper = styled.div`
  display: none;
  @media screen and ${device.md} {
    display: block;
  }
`;
const Inner = styled.div<{ $active?: boolean }>`
  flex-direction: column;
  @media screen and ${device.lg} {
    max-width: 130px;
  }
  @media screen and ${device.md} {
    ${({ $active }) => ($active ? 'display: block;' : 'display: none;')}
    margin-top:15px;
    max-width: none;
  }
`;
const Button = styled(Title)`
  display: none;
  @media screen and ${device.md} {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export { Container, Title, StyledLink, Inner, Button, DividerWrapper };
